import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

let prevPath: string | undefined;

/**
 * Adds a listener to the react-router history for compatibility with Segment.
 * @see https://www.pullrequest.com/blog/adding-segment-for-react/
 */
export const useSegmentNavigate = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname !== prevPath) {
            prevPath = location.pathname;
            analytics.page();
        }
    }, []);
    return navigate;
};
